export default "/assets/images/mila-feed-10-thumbnail.jpg?95844bf13c782a3732594c0069fe2e85";